import { render, staticRenderFns } from "./subscription-purchase-history.vue?vue&type=template&id=67fbd93a&scoped=true&"
import script from "./subscription-purchase-history.vue?vue&type=script&lang=js&"
export * from "./subscription-purchase-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fbd93a",
  null
  
)

export default component.exports